import { render, staticRenderFns } from "./AssignStudents.vue?vue&type=template&id=1b9c8e51"
import script from "./AssignStudents.vue?vue&type=script&lang=js"
export * from "./AssignStudents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports